<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-card-account-details
            </v-icon>
            <span class="title">Job Applicants</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-js">
              As jobseeker
              <v-icon large>mdi-briefcase-account</v-icon>
            </v-tab>
            <v-tab href="#tab-in">
              As student
              <v-icon large>mdi-school</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-js">
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="12" md="12">
                          <affix
                            relative-element-selector="#jobappcom-js"
                            :offset="{ top: 70, bottom: 70 }"
                            :class="!$vuetify.breakpoint.smAndDown ? 'container-affix-side' : 'top-zero'"
                            :enabled="!$vuetify.breakpoint.smAndDown">
                            <v-card
                              rounded="lg"
                              outlined>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" md="12">
                                    <div class="mb-1">
                                      <h2 class="text-md-h6 font-weight-bold mb-3">
                                        Job Vacancy
                                      </h2>
                                    </div>
                                    <v-autocomplete
                                      v-model="jobselect.js"
                                      :items="joblist"
                                      label="Job Vacancy"
                                      name="jobvacancy"
                                      item-text="job_name"
                                      return-object
                                      @change="selectJob('js')">
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12" md="12">
                                    <div class="mb-1">
                                      <h2 class="text-md-h6 font-weight-bold mb-3">
                                        Jobseeker Name
                                      </h2>
                                    </div>
                                    <v-text-field
                                      v-model="filterjs.search"
                                      label="Search"
                                      single-line
                                      hide-details>
                                    </v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="12">
                                    <v-btn
                                      large
                                      block
                                      :color="maincolor"
                                      class="mt-1 white--text"
                                      @click="getJobappjsFilter">
                                      <v-icon left dark>search</v-icon>
                                      Search
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card>
                          </affix>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8" id="jobappcom-js">
                      <v-row v-if="datajs.length > 0">
                        <v-col
                          class="d-flex" style="flex-direction:column"
                          cols="12"
                          md="6"
                          v-for="(djs, i) in datajs"
                          :key="i">
                          <applicant :data="djs"></applicant>
                        </v-col>
                      </v-row>
                      <v-row v-if="datajs.length <= 0">
                        <v-col cols="12" md="12" class="text-center black--text">
                          <span>Data not available!</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <infinite-loading :identifier="infiniteId" @infinite="getJobappjs">
                            <div slot="spinner">Loading...</div>
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                          </infinite-loading>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-in">
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="12" md="12">
                          <affix
                            relative-element-selector="#jobappcom-in"
                            :offset="{ top: 70, bottom: 70 }"
                            :class="!$vuetify.breakpoint.smAndDown ? 'container-affix-side' : 'top-zero'"
                            :enabled="!$vuetify.breakpoint.smAndDown">
                            <v-card
                              rounded="lg"
                              outlined>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" md="12">
                                    <div class="mb-1">
                                      <h2 class="text-md-h6 font-weight-bold mb-3">
                                        Job Vacancy
                                      </h2>
                                    </div>
                                    <v-autocomplete
                                      v-model="jobselect.in"
                                      :items="joblist"
                                      label="Job Vacancy"
                                      name="jobvacancy"
                                      item-text="job_name"
                                      return-object
                                      @change="selectJob('in')">
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12" md="12">
                                    <div class="mb-1">
                                      <h2 class="text-md-h6 font-weight-bold mb-3">
                                        Student Name
                                      </h2>
                                    </div>
                                    <v-text-field
                                      v-model="filterin.search"
                                      label="Search"
                                      single-line
                                      hide-details>
                                    </v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="12">
                                    <v-btn
                                      large
                                      block
                                      :color="maincolor"
                                      class="mt-1 white--text"
                                      @click="getJobappinFilter">
                                      <v-icon left dark>search</v-icon>
                                      Search
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card>
                          </affix>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8" id="jobappcom-in">
                      <v-row v-if="datain.length > 0">
                        <v-col
                          class="d-flex" style="flex-direction:column"
                          cols="12"
                          md="6"
                          v-for="(din, i) in datain"
                          :key="i">
                          <applicantintern :data="din"></applicantintern>
                        </v-col>
                      </v-row>
                      <v-row v-if="datain.length <= 0">
                        <v-col cols="12" md="12" class="text-center black--text">
                          <span>Data not available!</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <infinite-loading :identifier="infiniteIdin" @infinite="getJobappin">
                            <div slot="spinner">Loading...</div>
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                          </infinite-loading>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { Affix } from 'vue-affix';
import Applicant from '../../components/Applicant.vue';
import Applicantintern from '../../components/Applicantintern.vue';

export default {
  name: 'JobappCompany',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      adddata: false,
      uptdata: false,
      getdatajs: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    listtype: process.env.VUE_APP_TYPEJOB.split(','),
    joblist: [],
    datalist: [],
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 200 || 'Max 200 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    filterjs: {
      job_id: '',
      search: '',
      limit: 20,
      offset: 0,
    },
    filterin: {
      job_id: '',
      search: '',
      limit: 20,
      offset: 0,
    },
    jobselect: {
      js: null,
      in: null,
    },
    datajs: [],
    datain: [],
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      addtgljob: false,
      updtgljob: false,
      updatetglberita: false,
    },
    infiniteId: +new Date(),
    infiniteIdin: +new Date(),
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.listtype.pop();
    this.changeTab();
  },
  filters: {},
  methods: {
    changeTab() {
      if (this.tabdata === 'tab-js') {
        this.getJobappjsFilter();
      } else if (this.tabdata === 'tab-in') {
        this.getJobappinFilter();
      }
      this.getJobs();
    },
    selectJob(type) {
      this.filterjs.job_id = this.jobselect.js.job_id;
      if (type === 'in') {
        this.filterin.job_id = this.jobselect.in.job_id;
      }
      // console.log(this.jobselect.js);
    },
    getJobappinFilter() {
      this.filterin.offset = 0;
      this.datain = [];
      this.infiniteIdin += 1;
    },
    getJobappin($state) {
      if (this.tokenscr && this.filterin.job_id) {
        this.axios
          .get(
            this.api + '/api/jobs/apply-in-com',
            {
              params: this.filterin,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.filterin.offset += this.filterin.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.js_picture;
                    element.urlresume = this.api + '/upload/resume/' + element.js_resume;
                    element.urlskantar = '';
                    if (element.appin_sk_antar !== '') {
                      element.urlskantar = this.api + '/upload/sk/' + element.appin_sk_antar;
                    }
                    element.urlskmohon = '';
                    if (element.appin_sk_mohon !== '') {
                      element.urlskmohon = this.api + '/upload/sk/' + element.appin_sk_mohon;
                    }
                    this.datain.push(element);
                  });
                  // console.log(this.datain);
                  // this.datain.push(...resdata.data);
                  if (this.datain.length < this.filterin.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getJobappjsFilter() {
      this.filterjs.offset = 0;
      this.datajs = [];
      this.infiniteId += 1;
    },
    getJobappjs($state) {
      if (this.tokenscr && this.filterjs.job_id) {
        this.axios
          .get(
            this.api + '/api/jobs/apply',
            {
              params: this.filterjs,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.filterjs.offset += this.filterjs.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.js_picture;
                    element.urlresume = this.api + '/upload/resume/' + element.js_resume;
                    this.datajs.push(element);
                  });
                  // console.log(this.datajs);
                  // this.datajs.push(...resdata.data);
                  if (this.datajs.length < this.filterjs.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getJobs() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jobs/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.joblist = resdata.data;
                if (this.joblist.length > 0) {
                  this.jobselect.js = this.joblist[0];
                  this.selectJob('js');
                  this.getJobappjsFilter();
                  this.jobselect.in = this.joblist[0];
                  this.selectJob('in');
                }
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    VueEditor,
    Affix,
    Applicant,
    Applicantintern,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
